import React from "react";
import { useState } from "react";
import axios from "axios";
import { useNavigate} from 'react-router-dom'
import { ChatState } from "../asset/context";
function Login() {
  const {ENDPOINT,setLoading}  = ChatState()
  const [login, setLogin] = useState(true);
  const history = useNavigate()
  const [loginData, setLogindata] = useState({
    email: "",
    password: "",
  });
  const [registerData, setRegisterdata] = useState({
    fullname: "",
    email: "",
    password: "",
  });

  const registervalue = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setRegisterdata((val) => {
      return { ...val, [name]: value };
    });
  };

  const loginvalue = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setLogindata((val) => {
      return { ...val, [name]: value };
    });
  };
  //// SUBMIT
  const loginUser = async (event) => {
    event.preventDefault();
    setLoading(true)
    try {
      const { email, password } = loginData;
    const { data } = await axios.post(`${ENDPOINT}/login`, {
      email,
      password,
    });
    if (data) {
      localStorage.setItem("Vediocalltoken", JSON.stringify(data.matchUser))
      setLoading(false)
      
      history(`/contact/?_id=${data.matchUser._id}`)

    }
    } catch (error) {
      setLoading(false)

      alert(error.response.data.message);
      
    }
    
  };

  const registerUser = async (event) => {
    event.preventDefault();
    setLoading(true)

    try {
      const {fullname, email, password } = registerData;
    const { data } = await axios.post(`${ENDPOINT}/register`, {
      fullname,
      email,
      password,
    });
    if (data) {
      localStorage.setItem("Vediocalltoken", JSON.stringify(data))
      setLoading(false)
      
      history(`/contact/?_id=${data.matchUser._id}`)
    }
    } catch (error) {
      setLoading(false)

      alert(error.response.data.message);
      
    }
    
  };

  return (
    <>
      <div className="Navbar_main_box">
        <div className="navbar_logo">
          {/* <img src={logoImg} alt="" /> */}
          <h3>P</h3>
        <h1>2</h1>
        <h3>P</h3>
        <h2>CALL</h2>
        </div>
        {/* <div className="navbar_button"><button onClick={() => history('/login')}>Login Now</button></div> */}
      </div>
      <div className="login_main">
        <div
          className="login_innerbox"
          style={{ height: `${login ? "55%" : "70%"}` }}
        >
          <div className="login_box_head">
            <h3 onClick={() => setLogin(true)}>
              <span
                style={{
                  borderBottom: `${login ? "1px solid #fff" : "none"}`,
                  padding: "4% 40%",
                }}
              >
                Login
              </span>
            </h3>
            <h3>
              <span
                onClick={() => setLogin(false)}
                style={{
                  borderBottom: `${login ? "none" : "1px solid #fff"}`,
                  padding: "4% 40%",
                }}
              >
                Register
              </span>
            </h3>
          </div>
          <form
            method="GET"
            onSubmit={loginUser}
            className="login_box_login"
            style={{ display: `${login ? "flex" : "none"}` }}
          >
            <label>E-mail</label>
            <input
              type="email"
              placeholder="Enter your  email..."
              value={loginData.email}
              name="email"
              onChange={loginvalue}
            />
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter your Password..."
              value={loginData.password}
              name="password"
              onChange={loginvalue}
            />
            <button type="submit">Login</button>
          </form>
          <form
            method="POST"
            onSubmit={registerUser}
            className="login_box_login"
            style={{ display: `${login ? "none" : "flex"}` }}
          >
            <label>FullName</label>
            <input
              type="text"
              placeholder="Enter your display fullname..."
              onChange={registervalue}
              name="fullname"
            />
            <label>E-mail </label>
            <input
              type="email"
              placeholder="Enter your display email..."
              onChange={registervalue}
              name="email"
            />
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter your Password.."
              onChange={registervalue}
              name="password"
            />
            <button type="submit">Register</button>
          </form>
        </div>
      </div>
    </>
  );
}

export default Login;
